<template>
  <v-card tile style="overflow-y: scroll">
    <v-container>
      <v-row>
        <v-col cols="12" class="pa-2">
          <v-btn slot="append" small color="primary" dark @click="conference()">
            <v-icon dark>mdi-card-account-phone</v-icon>
            <span class="ml-2">Sala de conferencia</span>
          </v-btn>
          <v-form
            ref="form"
            v-model="valid"
            onsubmit="return false;"
            lazy-validation
          >
            <!-- <v-select
              v-model="queue"
              label="Fila"
              :items="filasAgente"
              required
              :rules="[v => !!v || 'Campo obrigatório']"
            ></v-select>-->
            <v-text-field
              color="green"
              v-model="numero"
              :label="t('informeUmNumero')"
              v-on:keyup.enter="disca"
              required
              :rules="[(v) => !!v || 'Campo obrigatório']"
            >
              <v-btn slot="append" small color="green" dark @click="disca">
                <v-icon dark>mdi-phone</v-icon>
              </v-btn>
            </v-text-field>
          </v-form>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="4"
          v-for="i in 9"
          class="pa-2"
          :key="i"
          @click="numero += i"
        >
          <v-btn block class="text-center" title @click="session.dtmf(i)">{{
            i
          }}</v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4" class="pa-2">
          <v-btn
            block
            class="text-center"
            title
            @click="
              numero += '*';
              session.dtmf('*');
            "
            >*</v-btn
          >
        </v-col>
        <v-col cols="4" class="pa-2">
          <v-btn
            block
            class="text-center"
            title
            @click="
              numero += '0';
              session.dtmf('0');
            "
            >0</v-btn
          >
        </v-col>
        <v-col cols="4" class="pa-2">
          <v-btn
            block
            class="text-center"
            title
            @click="
              numero += '#';
              session.dtmf('#');
            "
            >#</v-btn
          >
        </v-col>
      </v-row>
      <!-- <v-card v-if="calls.length > 0">
        <v-card-title>{{ t("ligacoesAtivas") }}</v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <tbody class="grey lighten-4">
                <tr v-for="call in calls" :key="call.callid">
                  <td>{{ call.numero }}</td>
                  <td>{{ call.nome }}</td>
                  <td class="text-end">
                    <v-btn
                      v-if="call.atendida"
                      icon
                      class="mr-2"
                      @click="confirmTransfer(call.callid)"
                    >
                      <v-icon>mdi-phone-forward</v-icon>
                    </v-btn>                  
                    <v-btn
                      v-if="call.atendida"
                      icon
                      class="mr-2"
                      @click="toggleMic(call)"
                    >
                      <v-icon v-if="call.mic">mdi-microphone</v-icon>
                      <v-icon v-else>mdi-microphone-off</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="call.atendida"
                      icon
                      class="mr-2"
                      @click="togglePause(call)"
                    >
                      <v-icon v-if="call.pause">mdi-play</v-icon>
                      <v-icon v-else>mdi-pause</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="!call.atendida"
                      icon
                      dark
                      class="mr-2"
                      color="green"
                      @click="atender(call.callid)"
                    >
                      <v-icon>mdi-phone</v-icon>
                    </v-btn>
                    <v-btn icon dark color="red" @click="desligar(call.callid)">
                      <v-icon>mdi-phone-hangup</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card> -->

      <v-dialog v-model="devicesModal">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title
            >Configurações de voz</v-card-title
          >
          <v-card-text>
            <v-select
              v-model="config.inputDevice"
              :items="inputDevices"
              :label="t('DispositivoDeEntrada')"
              :rules="[(v) => !!v || t('fraseCampoObrigatorio')]"
              required
            ></v-select>
            <v-select
              v-model="config.outputDevice"
              :items="outputDevices"
              :label="t('DispositivoDeSaida')"
              :rules="[(v) => !!v || t('fraseCampoObrigatorio')]"
              required
            ></v-select>
            <v-select
              v-model="config.ringDevice"
              :items="outputDevices"
              :label="t('DispositivoDeAlarme')"
              :rules="[(v) => !!v || t('fraseCampoObrigatorio')]"
              required
            ></v-select>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="devicesModal = false"
              >Cancelar</v-btn
            >
            <v-btn
              color="primary"
              text
              @click="
                setDevices();
                devicesModal = false;
              "
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="poptransfer">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title
            >Transferência</v-card-title
          >
          <v-card-text>
            <template v-if="calls.length > 1">
              <h4>{{ t("fraseSelecioneLigacao") }}</h4>
              <v-simple-table>
                <template v-slot:default>
                  <tbody class="grey lighten-4">
                    <tr
                      v-for="call in filterCalls(transfer.callid)"
                      :key="call.callid"
                    >
                      <td>{{ call.numero }}</td>
                      <td>{{ call.nome }}</td>
                      <td class="text-end">
                        <v-btn
                          icon
                          class="mr-2"
                          @click="AttendedTransfer(call.callid)"
                        >
                          <v-icon>mdi-phone-forward</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
            <v-form v-model="transfer.valid" @submit.prevent="Transferir">
              <v-text-field
                v-model="transfer.destino"
                label="Destino"
                required
                autofocus
                :rules="[(v) => !!v || 'É obrigatório']"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="poptransfer = false"
              >Cancelar</v-btn
            >
            <v-btn
              color="primary"
              text
              @click="setTransfer"
              :disabled="!transfer.valid"
              >Transferir</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <audio id="aremoto" autoplay></audio> -->
      <!-- <audio id="chamando" src="../assets/US_ringback_tone.ogg" type="audio/ogg" loop></audio>
      <audio id="tocando" src="../assets/S_Mirage_of_you.mp3" type="audio/mpeg" loop preload></audio>-->
      <!-- MODAL CLASSIFICACAO -->
      <Classificar
        :open="modalClassificacao"
        :atendimento="atendimento"
        :queueTypeID="1"
        v-on:updateClassificar:open="modalClassificacao = $event"
      />
      <!-- MODAL CLASSIFICACAO -->
    </v-container>
  </v-card>
</template>
   
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import Classificar from "./dialogs/Classificar";

//const win = require("win-audio");

export default {
  name: "Home",
  components: {
    Classificar,
  },
  props: {
    title: { type: String, default: "Title" },
    numero: { type: String, default: "" },
  },
  data: () => ({
    volume: 100,
    mic: 100,
    micGain: "",
    valid: false,
    queue: null,
    modalClassificacao: false,
    devicesModal: false,
    isMicMute: false,
    isMuted: false,
    isIncall: false,
    isRecebendo: false,
    poptransfer: false,
    transfer: { valid: false },
    classificacoes: [],
    classificacao: null,
    subclassificacoes: [],
    subclassificacao: null,
    obs: null,
    atendimento: null,
    config: JSON.parse(localStorage.getItem("config")),
    inputDevices: [],
    outputDevices: [],
  }),
  created() {
    if (this.$route.params.numero) this.numero = this.$route.params.numero;
    this.getHistoricoAtendimentosAgente({
      agente: this.user.fullname,
    });
  },
  watch: {
    calls() {
      this.getMeusAtendimentos();
    },

    // sessions() {
    //   this.toggleMicAll();
    // },
    fullname(nw) {
      if (nw && !this.config.webrtc) {
        if (this.user.filas[0].queue_type === 1) {
          this.queue = this.user.filas[0].fila;
        }
      }
    },
    isDiscando(newValue) {
      if (newValue) {
        this.chamando.currentTime = 0;
        this.chamando.play();
      } else {
        this.chamando.pause();
      }
    },

    volume(newValue) {
      this.setVolumePhone(newValue / 100);
    },
    mic(newValue) {
      this.setVolumeMic(newValue / 100);
      //win.mic.set(newValue);
    },
  },
  computed: {
    ...mapState("sip", {
      registered: (state) => state.registered,
      localAudio: (state) => state.localAudio.srcObject,
      calls: (state) => state.calls,
      sessions: (state) => state.sessions,
      streams: (state) => state.streams,
      isDiscando: (state) => state.isDiscando,
      isTocando: (state) => state.isTocando,
      isOcupado: (state) => state.isOcupado,
    }),
    ...mapState("auth", {
      user: (state) => state.user,
      fullname: (state) => state.user.fullname,
    }),
    audio: function () {
      return document.getElementById("aremoto");
    },
    chamando: function () {
      return document.getElementById("chamando");
    },
    tocando: function () {
      return document.getElementById("tocando");
    },
    session: function () {
      let call = this.calls.find((c) => !c.pause);
      if (call) {
        let session = this.sessions.find((s) => s.callid === call.callid);
        if (session) {
          return session;
        }
      }
      return null;
    },
    filasAgente() {
      return this.user.filas
        .filter((f) => f.queue_type === 1)
        .map((f) => f.fila);
    },
  },
  mounted() {
    // this.addLocalAudio(document.getElementById("aremoto"));
  },
  methods: {
    ...mapActions("sip", [
      "addLocalAudio",
      "atender",
      "desligar",
      "ligar",
      "Pausar",
      "Despausar",
      "MicOnOff",
      "Transferir",
      "setVolumeMic",
      "setVolumePhone",
      "changeDevices",
      "setMutePhoneAll",
      "setMuteMicAll",
      "addUserConference",
    ]),

    ...mapActions("xc", ["discar", ""]),
    filterCalls: function (callid) {
      return this.calls.filter((call) => call.callid !== callid);
    },
    confirmTransfer(callid) {
      this.transfer = {};
      this.transfer.valid = false;
      this.transfer.callid = callid;
      this.poptransfer = true;
    },
    setTransfer() {
      this.Transferir(this.transfer);
      this.poptransfer = false;
    },
    AttendedTransfer(callid) {
      this.transfer.callidDestino = callid;
      this.Transferir(this.transfer);
      this.poptransfer = false;
    },
    toggleMicAll() {
      this.isMicMute = !this.isMicMute;
      this.setMuteMicAll(this.isMicMute);
      // win.mic.isMuted() ? win.mic.unmute() : win.mic.mute();
      // this.isMicMute = win.mic.isMuted();
    },
    changeVol() {
      this.audio.volume = this.volume / 100;
    },
    toggleMic(call) {
      call.mic = !call.mic;
      this.MicOnOff({ callid: call.callid, mic: call.mic });
    },
    togglePause(call) {
      call.pause = !call.pause;
      if (call.pause) {
        this.Pausar(call.callid);
      } else {
        this.Despausar(call.callid);
      }
    },
    conference() {
      let agente = JSON.parse(localStorage.getItem(`user`));
      let dados = {};
      dados.nome = agente.nome;
      dados.ramal = agente.ramal;
      dados.numero = agente.ramal.split(`/`)[1];
      dados.sala = agente.ramal.split(`/`)[1];
      dados.qtdParticipantes = 1;
      dados.users = [];
      dados.users.push({ nome: agente.nome, numero: dados.numero });
      this.addUserConference(dados);
      // this.ligar(`*70${this.user.ramal_senha}`);
    },
    disca() {
      //if (this.isOcupado) return;
      if (!this.numero || this.numero === "") return;
      //if (this.numero && this.numero.length < 2) return;
      if (!this.$refs.form.validate()) return;

      // let dados = {
      //   ramal: this.user.ramal,
      //   contexto: this.user.contexto,
      //   fullname: this.fullname,
      //   numero: this.numero,
      //   queue: this.queue,
      // };
      // this.discar(dados);
      // this.isIncall = true;

      this.ligar(this.numero);

      this.isIncall = true;
      this.$emit("update", false);
      //this.phone.disca(this.numero);
      //this.chamando.play();
    },
    toggleMute() {
      //this.audio.volume = this.isMuted ? this.volume / 100 : 0;
      this.isMuted = !this.isMuted;
      this.setMutePhoneAll(this.isMuted);
    },
    getMicrofoneAnalizer() {
      navigator.mediaDevices
        .getUserMedia({ audio: true, video: false })
        .then(function (stream) {
          var audioContext = new AudioContext();
          var analyser = audioContext.createAnalyser();
          var microphone = audioContext.createMediaStreamSource(stream);
          var javascriptNode = audioContext.createScriptProcessor(2048, 1, 1);

          analyser.smoothingTimeConstant = 0.8;
          analyser.fftSize = 1024;

          microphone.connect(analyser);
          analyser.connect(javascriptNode);
          javascriptNode.connect(audioContext.destination);
          javascriptNode.onaudioprocess = function () {
            var array = new Uint8Array(analyser.frequencyBinCount);
            analyser.getByteFrequencyData(array);
            var values = 0;

            var length = array.length;
            for (var i = 0; i < length; i++) {
              values += array[i];
            }

            var average = values / length;

            console.log(Math.round(average));
            // colorPids(average);
          };
        })
        .catch(function (err) {
          console.error(err);
        });
    },

    ...mapActions(`xc`, [
      "getClassificacoes",
      "setClassificacaoLigacao",
      "getDefault",
      "getMeusAtendimentos",
      "getHistoricoAtendimentosAgente",
    ]),
    openClassificaModal(item) {
      let fila = this.getFilaByCall(item);
      item.fila = fila["X-Fila"];
      this.atendimento = item;
      this.modalClassificacao = true;
    },

    getFilaByCall(call) {
      let fila = call.dados.find((value) => {
        if (typeof value === "object") {
          let retorno = value["X-Fila"];
          if (retorno) {
            return retorno;
          }
        }
      });
      if (fila) {
        return fila;
      }
    },
    gotDevices(deviceInfos) {
      try {
        for (let i = 0; i !== deviceInfos.length; ++i) {
          const deviceInfo = deviceInfos[i];
          let value = deviceInfo.deviceId;
          if (deviceInfo.kind === "audioinput") {
            let text =
              deviceInfo.label || `microphone ${this.inputDevices.length + 1}`;
            this.inputDevices.push({ text: text, value: value });
          } else if (deviceInfo.kind === "audiooutput") {
            let text =
              deviceInfo.label || `speaker ${this.outputDevices.length + 1}`;
            this.outputDevices.push({ text: text, value: value });
          } else {
            console.log("Outro tipo de device ", deviceInfo);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>